import { render, staticRenderFns } from "./TransferMoneyDialog.vue?vue&type=template&id=c97632e0&scoped=true"
import script from "./TransferMoneyDialog.vue?vue&type=script&lang=js"
export * from "./TransferMoneyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97632e0",
  null
  
)

export default component.exports